import { render, staticRenderFns } from "./MainWindow.vue?vue&type=template&id=8b77ca8e&scoped=true"
import script from "./MainWindow.vue?vue&type=script&lang=js"
export * from "./MainWindow.vue?vue&type=script&lang=js"
import style0 from "./MainWindow.vue?vue&type=style&index=0&id=8b77ca8e&prod&lang=scss&scoped=true"
import style1 from "./MainWindow.vue?vue&type=style&index=1&id=8b77ca8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b77ca8e",
  null
  
)

export default component.exports